import { useSearchParams } from 'react-router-dom';
import { useParams } from 'src/routes/hooks';
import AccountCreatedSuccessView from 'src/sections/team-invite/view/account-created-success';

export default function AccountCreatedSuccessPage() {
  // hooks
  const params = useParams();
  const [searchParams] = useSearchParams();

  const { orgId, userId } = params;
  const token = searchParams.get('token');

  return (
    <AccountCreatedSuccessView orgId={orgId} userId={userId} token={token} />
  );
}
